import TextField from '@mui/material/TextField';
import { ClinicAccountItems } from '../../types/ClinicAccountType';
import Autocomplete, { AutocompleteRenderInputParams, createFilterOptions } from '@mui/material/Autocomplete';
import { styled, Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

const StyleAutocomplete = styled(Autocomplete)(({ theme }) => ({
  width: '49%',
  backgroundColor: theme.xPalette.white,
  '& .MuiOutlinedInput-root': {
    padding: '10px',
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

interface ClinicAccountAutoCompleteProps {
  value: number | string | null;
  onAccountChange: (value: number | string | null) => void;
  sx?: SxProps<Theme>;
  clinicAccounts?: ClinicAccountItems[];
}

function ClinicAccountAutoComplete({
  value,
  onAccountChange,
  sx,
  clinicAccounts,
}: ClinicAccountAutoCompleteProps) {
  const getAccountOptionLabel = (option: any) => `${option.name} (${option.id})`;
  const filterAccountOptions = createFilterOptions({
    matchFrom: 'any',
    stringify: (option: any) => getAccountOptionLabel(option),
  });

  return (
    <StyleAutocomplete
      data-testid="mui-component-select-clinic-account"
      options={clinicAccounts || []}
      getOptionLabel={getAccountOptionLabel}
      onChange={(_, newValue: any) => onAccountChange(newValue ? newValue.id : null)}
      value={value ? clinicAccounts?.find((item) => item.id === value) || null : null}
      filterOptions={filterAccountOptions}
      renderOption={(props, option: any) => {
        return (
          <li {...props} key={option.id} value={option.id}>
            {getAccountOptionLabel(option)}
          </li>
        );
      }}
      renderInput={(params: AutocompleteRenderInputParams) => (
        <TextField {...params} label="Select Account" variant="outlined" />
      )}
      sx={sx || { '&.MuiAutocomplete-root .MuiOutlinedInput-root': { pr: 1 } }}
    />
  );
}

export default ClinicAccountAutoComplete;
